import { Button, Modal as BootstrapModal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const HelpModal = ({ show, onCancel }) => {
    const [translate] = useTranslation();

    return (
        <BootstrapModal show={show} backdrop="static">
            <BootstrapModal.Header className="h5 text-secondary">
                {translate("OTM_HELP")}
                <Button onClick={onCancel} variant="danger" className="btn-sm">{translate("OTM_CLOSE")}</Button>
            </BootstrapModal.Header>
            <BootstrapModal.Body>
                <label className="h6">
                    Shortcuts:
                </label>
                <ul>
                    <li><b>Ctrl-A / Cmd-A</b> - Select All</li>
                    <li><b>Ctrl-C / Cmd-C</b> - Copy</li>
                    <li><b>Ctrl-V / Cmd-V</b> - Paste</li>
                    <li><b>Ctrl-Z / Cmd-Z</b> - Undo</li>
                    <li><b>Ctrl-Y / Cmd-Y</b> - Redo</li>
                    <li><b>Ctrl-F / Cmd-F</b> - Start searching</li>
                    <li><b>Ctrl-G / Cmd-G</b> - Find next</li>
                    <li><b>Shift-Ctrl-G / Shift-Cmd-G</b> - Find previous</li>
                    <li><b>Shift-Ctrl-F / Cmd-Option-F</b> - Replace</li>
                    <li><b>Shift-Ctrl-R / Shift-Cmd-Option-R</b> - Replace all</li>
                    <li><b>Alt-G</b> - Jump to line</li>
                </ul>
            </BootstrapModal.Body>
        </BootstrapModal>
    );

};

export default HelpModal;
